import { mapGetters, mapActions } from "vuex";
import { types as Home } from "@/store/home";
import { uleUrl } from "@/libs/common";

import { pilotCityList, pilotCityListNew, addOrUpdateApi } from "@/libs/api.js";

const getters = mapGetters({
  getCurrentCity: Home.CURRENT_CITY,
  getCurrentAdCode: Home.AD_CODE,
  getCurrentCityByMin: Home.CURRENT_CITY_MIN,
  getCurrentAdCodeByMin: Home.AD_CODE_MIN,
});
const actions = mapActions({
  setPioltCity: Home.IS_PIOLICity,
});
export default {
  name: "indexPick",
  data() {
    return {
      historySite: "", //  历史自提点
      ispioltCity: false, // 是否是试点城市
      pilotCityList: [], //  试点城市列表
      freshActType: "",
      querySiteParams: {
        longitude: "", // 经度 121.586118
        latitude: "", // 纬度  31.29371
        radius: "100", // 查询半径   	默认查询距离50公里
        areaId: "", // 定位区
        cityId: "", // 定位市
        provinceId: "", // 定位省
        sort: "0", // 排序字段   网点按距离远近排序。0:升序（默认）, 1:降序
        siteKeyword: "", // 搜索关键字  浦东新区浦江东旭公寓
        pageIndex: "1", // 页号
        pageSize: "10", // 每页显示数
        teamFlag: "2",
        teamUserId: "",
      },
      loading: false,
      finished: false,
      isClick: false,
      client_type: "wap_ylxdsq",
      siteList: "", // 自提点列表
      listStatus: 0, // 0-无状态 1-有数据 2-无数据 3-非试点
      siteImg: `https://i0.${process.env.VUE_APP_HOST_CDN}/ulewap/i/ylxdsq/siteImg.png`,
      currentIndex: null,
      ispilotcity: false,
    };
  },
  computed: {
    ...getters,
  },
  methods: {
    ...actions,
    getPilotCity(adcode) {
      // 试点城市
      const curProCode = String(adcode).slice(0, 2) + "0000"; // 转换成省code
      const curCityCode = String(adcode).slice(0, 4) + "00"; // 转换成市code
      pilotCityListNew(curProCode).then(
        (res) => {
          console.log();
          // eslint-disable-next-line no-unused-expressions
          if (
            res.code == "0000" &&
            res.data["ylyx_index_city_lists_" + curProCode] &&
            res.data["ylyx_index_city_lists_" + curProCode].length
          ) {
            res.data["ylyx_index_city_lists_" + curProCode].map((el) => {
              const item = el.customAttribute;
              if (item.codeType == 0) {
                //区
                if (item.code == adcode) {
                  this.ispioltCity = true;
                  this.freshActType = "1";
                }
              } else if (item.codeType == 1) {
                //市
                if (item.code == curCityCode) {
                  this.ispioltCity = true;
                  this.freshActType = "1";
                }
              } else if (item.codeType == 2) {
                //省
                if (item.code == curProCode) {
                  this.ispioltCity = true;
                  this.freshActType = "1";
                }
              }
              if (!this.ispioltCity) {
                console.log("非试点");
                this.toNext("/");
              }
            });
          } else {
            console.log("this.ispioltCity===", this.ispioltCity);
            console.log("非试点");
            this.toNext("/");
          }
          // 非试点城市标记
          if (this.$route.query.ispilotcity == "false") {
            this.freshActType = "";
          }

          this.setPioltCity(this.ispioltCity);
          document.cookie = `ispioltCity=${
            this.freshActType
          };domain=.${uleUrl()};path=/;`;
          if (this.ispioltCity) {
            this.selfPickupSite(curCityCode);
          }
          if (window.uleStatUtil) {
            window.uleStatUtil.sendView(location.href, {
              relateType: "ylxdsqHome",
              relateId1: adcode,
              relateId2: curCityCode,
              relateId3: this.ispioltCity ? "试点城市" : "",
            });
          }
          // console.log(res, '查询试点城市')
        },
        () => {
          // console.log('接口错误')
        }
      );
    },
    // 获取试点城市自提点
    selfPickupSite(adcode) {
      let that = this;
      if (that.isClick) {
        return false;
      }
      that.isClick = true;
      if (adcode) this.querySiteParams.cityId = adcode; //转换成市code
      // 如果有经纬度，则城市code为空
      if (this.querySiteParams.latitude && this.querySiteParams.longitude) {
        // this.querySiteParams.cityId = "";
        // this.querySiteParams.areaId = "";
      }
      // 获取试点城市自提点列表
      pilotCityList(this.querySiteParams, "site").then(
        (res) => {
          that.isClick = false;
          that.loading = false;
          if (res.data && res.data.result) {
            that.listStatus = 1;
            if (that.querySiteParams.pageIndex > 1) {
              that.siteList = that.siteList.concat(res.data.result);
            } else {
              that.siteList = res.data.result;
            }
          } else {
            that.siteList = [];
            that.listStatus = 2;
          }
          if (res.data && res.data.result) {
            if (res.data.result.length)
              this.cityName = res.data.result[0].cityName.replace("市", "");
          }
          if (
            !res.data ||
            that.querySiteParams.pageIndex >= res.data.totalPages
          ) {
            that.finished = true;
          }
        },
        () => {
          that.isClick = false;
        }
      );
    },
    // 加载更多
    moreSite() {
      if (this.isClick) {
        return false;
      }
      this.querySiteParams.pageIndex++;
      this.selfPickupSite();
    },
    siteTagName(tagName) {
      if (tagName) {
        let htm = "",
          arr = [];
        arr = tagName.split(",");
        for (let t = 0; t < arr.length; t++) {
          htm += `<span>${arr[t]}</span>`;
        }
        return htm;
      }
      return "";
    },
    // 点击选择自提点
    selectSite(site, index) {
      this.currentIndex = index;
      this.siteData = site;
    },
    // 确定自提点
    handleConfirmSite() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      console.log(this.siteData);
      let selectSite = {
        location: this.siteData.geoPoint,
        siteId: this.siteData.siteId,
        adcode: this.siteData.areaId,
        consigneeName: this.siteData.consigneeName,
        mobileNum: this.siteData.mobileNum,
      };
      addOrUpdateApi(selectSite).then((res) => {
        console.log("自提点更新成功");
        document.cookie = `selectSite=${JSON.stringify(
          selectSite
        )};domain=.${uleUrl()};path=/;`;
        setTimeout(() => {
          this.$toast.clear();
          this.toNext("/");
        }, 1000);
      });
    },
  },
  mounted() {
    this.client_type =
      this.$cookies.get("ul_sch") || this.$cookies.get("client_type");

    // 小程序环境
    if (this.$browser().miniprogram) {
      let arr = (this.getCurrentCityByMin.location || "").split(",");
      this.querySiteParams.latitude = arr[0];
      this.querySiteParams.longitude = arr[1];
      this.querySiteParams.areaId = this.getCurrentAdCodeByMin;
      this.querySiteParams.cityId = this.getCurrentAdCodeByMin;
      this.getPilotCity(this.getCurrentAdCodeByMin);
    }
    // H5环境
    else {
      if (this.getCurrentAdCode) {
        let arr = (this.getCurrentCity.location || "").split(",");
        this.querySiteParams.latitude = arr[0];
        this.querySiteParams.longitude = arr[1];
        this.querySiteParams.areaId = this.getCurrentAdCode;
        this.querySiteParams.cityId = this.getCurrentAdCode;
        this.getPilotCity(this.getCurrentAdCode);
        // this.getRecommend();
      }
    }
  },
};
